import React from "react";

import { IgCheckbox } from "@intelligems/ig-theme";
import { FormControlLabel, useTheme } from "@mui/material";

export interface CheckboxProps {
  label?: React.ReactNode;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

export const Checkbox = ({ label, checked, onChange }: CheckboxProps) => {
  const theme = useTheme();

  return (
    <FormControlLabel
      control={
        <IgCheckbox
          size="small"
          sx={{
            "&:not(.Mui-checked) .MuiSvgIcon-root": {
              color: theme.igBorders.core.default,
            },
          }}
          checked={checked}
          onChange={(e) => onChange?.(e.target.checked)}
        />
      }
      label={label}
      labelPlacement="end"
      sx={{ marginRight: 0 }}
    />
  );
};
